import React from 'react';
import { classes } from '../../../lib';
import Styles from './MediaTestimonial.module.less';

export type MediaTestimonialProps = {
    title: string;
    subtitle: string;
    color: string;
    caption: React.ReactNode;
    link: React.ReactNode;
    statement: React.ReactNode;
    name: string;
    jobTitle: string;
    logo: React.ReactNode;
};

export const MediaTestimonial = (p: MediaTestimonialProps): JSX.Element => {
    return (
        <div className={Styles.container}>
            <div className="vertical left-middle g40 d-pr24 mt-pb24">
                <div className="vertical stretch-top g16 self-stretch">
                    <div className="vertical stretch-top g8">
                        <span className={Styles.subtitle}>{p.subtitle}</span>
                        <h2 className={Styles.title}>{p.title}</h2>
                    </div>
                    <div className={classes('semilarge-alude', Styles.caption)}>
                        {p.caption}
                    </div>
                </div>
                {p.link}
            </div>
            <div className={classes(Styles.media, `bg-alude-${p.color}-6`)}>
                {p.logo}
            </div>
            <div
                className={classes(
                    'vertical stretch-middle g24 p24',
                    `bg-alude-${p.color}-1`,
                    Styles.testimonialContainer
                )}>
                <div className={Styles.statement}>{p.statement}</div>
                <div className="vertical stretch-top">
                    <div className="medium-alude semibold alude-gray-9">
                        {p.name}
                    </div>
                    <div className="medium-alude alude-gray-7">
                        {p.jobTitle}
                    </div>
                </div>
            </div>
        </div>
    );
};
